import React from 'react';
import './serviceAreas.css';

const ServiceAreas = () => {
  const areas = [
    { name: 'Sunshine', postcode: '3020' },
    { name: 'Werribee', postcode: '3030' },
    { name: 'Melbourne', postcode: '3004' },
    { name: 'Parkville', postcode: '3052' },
    { name: 'Truganina', postcode: '3029' },
    { name: 'Point Cook', postcode: '3030' },
    { name: 'Hoppers Crossing', postcode: '3029' },
    { name: 'Williams Landing', postcode: '3027' }
  ];

  return (
    <section className="service-areas section-padding" id="service-areas">
      <div className="container">
        <div className="section-title">
          <span className="title" data-aos="fade-up">Service Areas</span>
          <h2 className="sub-title" data-aos="fade-up">We Proudly Serve 8 Locations Across Melbourne</h2>
        </div>
        <div className="areas-grid">
          {areas.map((area, idx) => (
            <div 
              key={idx} 
              className="area-card" 
              data-aos="fade-up" 
              data-aos-delay={idx * 100}
            >
              <i className="fas fa-map-marker-alt"></i>
              <h3>{area.name}</h3>
              <p>VIC {area.postcode}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
